import { GET_COLLECTION_SUCCESS } from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_COLLECTION_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.collection.id] = action.payload.collection;
      return {
        data,
        isFetching: false,
        recordCount: action.payload.total
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getCollectionBySlug = (collections, slug) => {
  if (!collections.data) {
    return null;
  }
  const collectionIds = Object.keys(collections.data);
  const collectionBySlugId = collectionIds.find(
    (id) => collections.data[id].slug === slug
  );
  if (collectionBySlugId) {
    return collections.data[collectionBySlugId];
  }
  return null;
};
